import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace("#", "?")).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || "Échec de la connexion");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-ink text-white">
      {error ? (
        <div className="text-center max-w-md px-6" data-testid="auth-callback-error">
          <p className="text-red-400 font-medium">{error}</p>
          <button
            data-testid="auth-back-login-btn"
            onClick={() => { window.location.href = "/login"; }}
            className="mt-6 rounded-lg bg-emerald-500 px-5 py-2.5 text-sm font-medium text-white hover:bg-emerald-600"
          >
            Retour à la connexion
          </button>
        </div>
      ) : (
        <Loader2 className="h-6 w-6 animate-spin text-emerald-400" data-testid="auth-callback-loader" />
      )}
    </div>
  );
}
